import { _ as _baseCreate } from './_baseCreate.mjs';
import { _ as _getPrototype } from './_getPrototype.mjs';
import { _ as _isPrototype } from './_isPrototype.mjs';

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

export { _initCloneObject as _ };
